import '@/shared/components/toggle/toggle.scss';

export default function Toggle({
  checked,
  onChange,
  disabled,
}: {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const interactive = !!onChange && !disabled;

  return (
    <span
      className={`toggle-switch${checked ? ' toggle-switch-on' : ''}${disabled ? ' toggle-switch-disabled' : ''}`}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled || undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={interactive ? () => onChange!(!checked) : undefined}
      onKeyDown={
        interactive
          ? event => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onChange!(!checked);
              }
            }
          : undefined
      }
    >
      <span className="toggle-switch-knob" />
    </span>
  );
}
